// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__24ROR","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__bcdX5"};